module.exports = __webpack_public_path__ + "static/media/google.14c3d799.svg";